export const baseHeader = [
  { label: 'Programme', key: 'interventionProgramme' },
  { label: 'Service Provider', key: 'interventionServiceProvider' },
  { label: 'Intervention ID', key: 'interventionId' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'interventionSubject' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Year', key: 'year' },
];

export const testPerformanceExportBaseColumn = [
  { label: 'Term', key: 'term' },
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Grade', key: 'grade.value' },
  { label: 'Subject', key: 'subject.name' },
  { label: 'Previous Promotion Status', key: 'prevPromStatus' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Number Absent', key: 'numberAbsent' },
  { label: 'Number Wrote', key: 'numberWrote' },
  { label: 'Level 1', key: 'level1' },
  { label: 'Level 2', key: 'level2' },
  { label: 'Level 3', key: 'level3' },
  { label: 'Level 4', key: 'level4' },
  { label: 'Level 5', key: 'level5' },
  { label: 'Level 6', key: 'level6' },
  { label: 'Level 7', key: 'level7' },
  { label: 'Pass Rate', key: 'passRate' },
  { label: 'Average Mark', key: 'averageMark' },
];

export const schoolSubjectReportExportBaseColumn = [
  { label: 'Term', key: 'term' },
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EmisNumber', key: 'emisNumber' },
  { label: 'Grade', key: 'grade.value' },
  { label: 'Subject', key: 'subject.name' },
  { label: 'Prev Promotion Status', key: 'promotionStatus.name' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Number Absent', key: 'numberAbsent' },
  { label: 'Number Wrote', key: 'numberWrote' },
  { label: 'Level 1', key: 'level1' },
  { label: 'Level 2', key: 'level2' },
  { label: 'Level 3', key: 'level3' },
  { label: 'Level 4', key: 'level4' },
  { label: 'Level 5', key: 'level5' },
  { label: 'Level 6', key: 'level6' },
  { label: 'Level 7', key: 'level7' },
  { label: 'Pass Rate', key: 'PassRate' },
  { label: 'Average Mark', key: 'averageMark' },
];

export const NSCProgressionExportBaseColumn = [
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Number Progressed', key: 'numberProgressed' },
  { label: 'Number Wrote', key: 'numberWrote' },
  { label: 'Number Achieved', key: 'numberAchieved' },
  { label: 'Percentage Achieved', key: 'percentageAchieved' },
  { label: 'Number Achieved: Progressed', key: 'numberAchievedProgressed' },
  { label: 'Number Bachelors', key: 'numberBachelors' },
  { label: 'Percentage Bachelors', key: 'percentageBachelors' },
  { label: 'Number Diploma', key: 'numberDiploma' },
  { label: 'Percentage Diploma', key: 'percentageDiploma' },
  { label: 'Number Higher Certificate', key: 'numberHigherCertificate' },
  { label: 'Percentage Higher Certificate', key: 'percentageHigherCertificate' },
  { label: 'Number NSC Pass', key: 'numberNSCPass' },
  { label: 'Percentage NSC Pass', key: 'percentageNSCPass' },
  { label: 'Number NSC Fail', key: 'numberNSCFail' },
  { label: 'Percentage NSC Fail', key: 'percentageNSCFail' },
];

export const NSCSubjectExportBaseColumn = [
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Subject', key: 'subject.name' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Number Wrote', key: 'numberWrote' },
  { label: 'Number Achieved', key: 'numberAchieved' },
  { label: 'Percentage Achieved', key: 'percentageAchieved' },
  { label: 'Number Achieved with Distinction', key: 'numberAchievedWithDistinction' },
  { label: 'Percentage Achieved with Distinction', key: 'percentageAchievedWithDistinction' },
  { label: 'Number of Progressed Learners', key: 'numberProgressedLearners' },
  { label: 'Number Wrote: Progressed Learners', key: 'numberWroteProgressedLearners' },
  { label: 'Number Achieved: Progressed Learners', key: 'numberAchievedProgressedLearners' },
  { label: 'Percentage Achieved: Progressed Learners', key: 'percentageAchievedProgressedLearners' },
];

export const schoolAttendanceBaseColumn = [
  { label: 'Term', key: 'term' },
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Grade', key: 'grade.value' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Possible Attendance', key: 'possibleAttendance' },
  { label: 'Absent Days', key: 'absentDays' },
  { label: 'Actual Attendance', key: 'actualAttendance' },
  { label: 'Attendance Rate', key: 'attendanceRate' },
  { label: 'Absenteeism Rate', key: 'absenteeismRate' },
];

export const schoolPromotionBaseColumn = [
  { label: 'Term', key: 'term' },
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Grade', key: 'grade.value' },
  { label: 'Promotion Status', key: 'promotionStatus.name' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Number Wrote', key: 'numberWrote' },
  { label: 'Number Passed', key: 'numberPassed' },
  { label: 'Percentage Passed', key: 'percentagePassed' },
  { label: 'Grade Average', key: 'gradeAverage' },
];

export const schoolEducatorBaseColumn = [
  { label: 'Term', key: 'term' },
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Educator Name', key: 'educatorName' },
  { label: 'Attendance Rate', key: 'attendanceRate' },
  { label: 'Days Absent', key: 'daysAbsent' },
];

export const schoolEnrolmentBaseColumn = [
  { label: 'Term', key: 'term' },
  { label: 'District', key: 'district.name' },
  { label: 'Circuit', key: 'circuit.name' },
  { label: 'Institution', key: 'institution.name' },
  { label: 'EMIS Number', key: 'emisNumber' },
  { label: 'Grade', key: 'grade.value' },
  { label: 'Promotion Status', key: 'promotionStatus.name' },
  { label: 'Number Enrolled', key: 'numberEnrolled' },
  { label: 'Number Without ID', key: 'numberWithoutID' },
];

export const onlyInterventionHeader = [
  { label: 'Programme', key: 'interventionProgramme' },
  { label: 'Service Provider', key: 'interventionServiceProvider' },
  { label: 'Intervention ID', key: 'interventionId' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'interventionSubject' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Year', key: 'year' },
];

export const onlyProgrammeHeader = [
  { label: 'Programme', key: 'interventionProgramme' },
  { label: 'Year', key: 'year' },
];

export const onlyServiceProviderHeader = [
  { label: 'Programme', key: 'interventionProgramme' },
  { label: 'Service Provider', key: 'interventionServiceProvider' },
  { label: 'Year', key: 'year' },
];
